var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sponsor-licence"},[_c('ComplianceProfile',{attrs:{"type":_vm.type}}),(_vm.isSLStarted)?_c('nb-btn',{staticClass:"sponsor-licence__button",attrs:{"label":"View the case","secondary":""},on:{"click":function($event){return _vm.fetchSLCaseId()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }